import { auth } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  updatePassword,
  signInWithPopup,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
  updateProfile,
  signOut,
} from "firebase/auth";

// Global variable to store if we're in debug mode (test1@gmail.com)
let isDebugMode = false;






// Account Creation with Email/Password
export const doCreateUserWithEmailAndPassword = async (email, password, name) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Set the display name after account creation
    await updateProfile(user, {
      displayName: name
    });

    console.log("User created:", user);

    await signOut(auth);  // Sign out the user after successful registration
    return userCredential;
  } catch (error) {
    console.error("Error in account creation:", error);
    throw error; // Throw error to be caught by the caller
  }
};


// Sign-In with Email/Password and Set Persistence
export const doSignInWithEmailAndPassword = async (email, password) => {
  const allowedEmails = ["janith.wickramasooriya@Companytravels.com","achalanga.ayagama@Companytravels.com","contact.chathuranga@gmail.com","chinthaka.lakshman@gmail.com","janithwickramasooriya@gmail.com","psihasuni@gmail.com", "chinthaka@evoqsystems.com","chathuranga@evoqsystems.com","chamod.s@evoqsystems.com","sandun.ds94@gmail.com","shenalikumarathunga2001@gmail.com","thiliniwijesinghe2000@gmail.com","chinthaka.lakshman@gmail.com","shuhany.hassen@Companytravels.com","leon.peiris@Companytravels.com","nicola.ranabahu@Companytravels.com","dhanushika.jeyakirupal@Companytravels.com","kariyawasam.ck18@gmail.com","ops@Companytravels.com","shenal.wijesekara@Companytravels.com","usher.crusz@Companytravels.com","india@Companytravels.com",
    "sherman.r@Companytravels.com","Dinesh.Mendis@Companytravels.com","gavin.loos@Companytravels.com","dinesh.mendis@Companytravels.com","test1@gmail.com"];

  if (!allowedEmails.includes(email)) {
    alert("Your email is not authorized to access this application.");
    throw new Error("Unauthorized email");
  }

  // Set debug mode if the email is test1@gmail.com
  isDebugMode = email.toLowerCase() === "test1@gmail.com";
  console.log("Debug mode:", isDebugMode);

  try {
    await setPersistence(auth, browserLocalPersistence);
    return await signInWithEmailAndPassword(auth, email, password);
  } catch (error) {
    console.error("Sign-in error:", error.message);
    throw error;
  }
};

export const doSignInWithGoogle = async () => {
  const allowedEmails = ["janith.wickramasooriya@Companytravels.com","achalanga.ayagama@Companytravels.com","contact.chathuranga@gmail.com","chinthaka.lakshman@gmail.com","janithwickramasooriya@gmail.com","psihasuni@gmail.com", "chinthaka@evoqsystems.com","chathuranga@evoqsystems.com","chamod.s@evoqsystems.com","sandun.ds94@gmail.com","shenalikumarathunga2001@gmail.com","thiliniwijesinghe2000@gmail.com","chinthaka.lakshman@gmail.com","shuhany.hassen@Companytravels.com","leon.peiris@Companytravels.com","nicola.ranabahu@Companytravels.com","dhanushika.jeyakirupal@Companytravels.com","kariyawasam.ck18@gmail.com","ops@Companytravels.com","shenal.wijesekara@Companytravels.com","usher.crusz@Companytravels.com"
    ,"india@Companytravels.com","sherman.r@Companytravels.com","Dinesh.Mendis@Companytravels.com","gavin.loos@Companytravels.com","dinesh.mendis@Companytravels.com","test1@gmail.com"]

  const provider = new GoogleAuthProvider();

  try {
    await setPersistence(auth, browserLocalPersistence);
    const result = await signInWithPopup(auth, provider);
    const userEmail = result.user.email;

    if (!allowedEmails.includes(userEmail)) {
      alert("Your email is not authorized to access this application.");
      await doSignOut();
      throw new Error("Unauthorized email");
    }

    // Set debug mode if the email is test1@gmail.com
    isDebugMode = userEmail.toLowerCase() === "test1@gmail.com";
    console.log("Debug mode:", isDebugMode);

    return result;
  } catch (error) {
    console.error("Google Sign-In Failed:", error.message);
    throw error;
  }
};


// Sign-Out Function
export const doSignOut = async () => {
  try {
    await signOut(auth);
    console.log("User successfully signed out");
  } catch (error) {
    console.error("Error signing out:", error);
  }
};


// Password Reset with confirmation message
export const doPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    console.log("Password reset email sent successfully.");
  } catch (error) {
    console.error("Error sending password reset email:", error.message);
    throw error;
  }
};


// Password Change
export const doPasswordChange = (password) => {
  return updatePassword(auth.currentUser, password);
};

// Email Verification
export const doSendEmailVerification = () => {
  return sendEmailVerification(auth.currentUser, {
    url: `${window.location.origin}/home`,
  });
};

// Check if we're in debug mode (test1@gmail.com)
export const isInDebugMode = () => {
  return isDebugMode;
};
